import Vue from 'vue'
import { assert } from 'chai'
import CONFIG from '~config/env.js'

export default {
  getAllNotifications({ dispatch, state }, filter) {
    return dispatch('getItems', {
      state,
      loader: 'notifications',
      modelName: 'notifications',
      orderBy: 'created_at',
      filter,
      endpoint: CONFIG.ISHIKAWA.ENDPOINTS.NOTIFICATIONS
    })
  },
  getUnreadNotifications({ dispatch, state }) {
    return dispatch('getItems', {
      state,
      loader: 'notifications',
      modelName: 'notifications',
      orderBy: 'created_at',
      filter: { user_id: Vue.loggedUser.id, read_at__isnull: true },
      endpoint: CONFIG.ISHIKAWA.ENDPOINTS.NOTIFICATIONS
    })
  },
  updateNotification({ state, dispatch }, notification) {
    return dispatch('updateItem', {
      item: notification,
      state,
      addTo: ['notifications'],
      loader: 'notification:persist',
      endpoint: CONFIG.ISHIKAWA.ENDPOINTS.NOTIFICATIONS
    })
  },
  updateNotifications({ state, dispatch }, payload) {
    assert.exists(payload.filter)
    assert.exists(payload.value)

    return dispatch('updateItems', {
      filter: payload.filter,
      filterToGetDataAfterUpdate: payload.filterToGetDataAfterUpdate,
      value: payload.value,
      state,
      addTo: ['notifications'],
      loader: 'notifications:update',
      endpoint: CONFIG.ISHIKAWA.ENDPOINTS.NOTIFICATIONS
    })
  }
}
